import { useEffect, useRef, useState } from "react";

const VIEWPORT_WIDTH = 584;
const VIEWPORT_HEIGHT = 591;
const SHADOW = "0 16px 40px oklch(0.12 0.008 75 / 0.08)";
const SRC = `/scout-demo-animation.html?v=${Date.now()}`;

const ScoutDemoEmbed = ({ active }: { active: boolean }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);
  const [chatRevealed, setChatRevealed] = useState(false);

  useEffect(() => {
    const update = () => {
      if (containerRef.current) {
        setScale(containerRef.current.clientWidth / VIEWPORT_WIDTH);
      }
    };
    update();
    const ro = new ResizeObserver(update);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.scout === "typing") setChatRevealed(false);
      if (e.data?.scout === "chat") setChatRevealed(true);
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  // Reset chat reveal state when deactivated
  useEffect(() => {
    if (!active) setChatRevealed(false);
  }, [active]);

  const src = active ? SRC : "";

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: `${VIEWPORT_HEIGHT * scale}px`,
        overflow: "hidden",
        borderRadius: "20px",
        background: "oklch(var(--surface-panel))",
        border: "1.5px solid oklch(var(--border))",
        boxShadow: chatRevealed ? SHADOW : "none",
        transition: "box-shadow 0.5s ease",
      }}
    >
      <iframe
        title="Scout demo animation"
        src={src}
        tabIndex={-1}
        style={{
          display: "block",
          border: 0,
          background: "transparent",
          width: `${VIEWPORT_WIDTH}px`,
          height: `${VIEWPORT_HEIGHT}px`,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default ScoutDemoEmbed;
